import React, { Component } from "react";
import { connect } from "react-redux";
import "../../../styles/components/chargers/modals/CreateB2B.scss";
import { Modal, Button, Form } from "react-bootstrap";
import Cross from "../../../../src/styles/images/cross.svg";
import PhoneInput from "react-phone-input-2";
import { CountryDropdown } from "react-country-region-selector";
import axios, { CancelToken } from "axios";
import { I18n } from "react-redux-i18n";
import eyePassword from "../../../styles/images/eyePassword.svg";
import parsePhoneNumber from "libphonenumber-js/max";

class CreateB2B extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      name: "",
      password: "",
      passwordConfirmation: "",
      email: "",
      phone: "",
      country: "",
      countryPrefix: "pt",
      confirmationStep: false,
      phoneValidated: false,
      nameValidated: false,
    };
    this.handleChangePhone2 = this.handleChangePhone2.bind(this);
    this.confirmAllFieldsAreFiled = this.confirmAllFieldsAreFiled.bind(this);
    this.isPhoneNumberValid = this.isPhoneNumberValid.bind(this);
    this.togglePasswordVisibility = this.togglePasswordVisibility.bind(this);
  }

  confirmAllFieldsAreFiled() {
    const { name, password, passwordConfirmation, email, phone, country } =
      this.state;

    const allFieldsFilled =
      name !== "" &&
      password !== "" &&
      passwordConfirmation !== "" &&
      email !== "" &&
      phone !== "" &&
      country !== "";

    return allFieldsFilled;
  }

  isPhoneNumberValid = () => {
    const { phone } = this.state;
    try {
      const phoneNumber = parsePhoneNumber(`+${phone}`);

      if (phoneNumber) {
        const phoneType = phoneNumber.getType();
        return (
          phoneType === "FIXED_LINE" ||
          phoneType === "MOBILE" ||
          phoneType === "FIXED_LINE_OR_MOBILE"
        );
      }
      return false;
    } catch (error) {
      return false;
    }
  };

  togglePasswordVisibility() {
    this.setState((prevState) => ({
      passwordVisible: !prevState.passwordVisible,
    }));
  }
  componentDidMount() {
    this._mounted = true;
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  handleChange = (e) => {
    e.preventDefault();
    this.setState({ [e.target.name]: e.target.value });
  };

  handleChangePhone2 = (name, country, value) => {
    this.setState({ [name]: value, countryPrefix: country.dialCode });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const fullNumber = this.state.phone;
    const prefix = this.state.countryPrefix;
    const numberWithoutPrefix = fullNumber.substring(prefix.length);

    let params = {
      name: this.state.name,
      username: numberWithoutPrefix,
      password: this.state.password,
      confPassword: this.state.passwordConfirmation,
      email: this.state.email,
      mobile: numberWithoutPrefix,
      country: this.state.country,
      countryPrefix: this.state.countryPrefix,
    };

    axios
      .post("/api/private/users/b2b", {
        name: this.state.name,
        username:
          this.props.brand.clientName === "EVIO"
            ? numberWithoutPrefix
            : this.state.email,
        password: this.state.password,
        confPassword: this.state.passwordConfirmation,
        email: this.state.email,
        mobile: numberWithoutPrefix,
        country: this.state.country,
        internationalPrefix: "+" + this.state.countryPrefix,
        payment_method:"AD_HOC",
        payment_instrument: "WALLET_AND_CARD",
        payment_terms: "30_DAY",
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((response) => {
        this.props.filterCreatedUser(params);
        this.props.callSuccess();
        this.props.onHide();
      })
      .catch((err) => {
        if (err.response) {
          this.props.callFailure(err.response.data.message);
          this.setState({ confirmationStep: false });
        } else if (err.request) {
          console.log(err.request);
        } else {
          console.log("Error", err.message);
        }
      });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.show !== this.props.show) {
      this.setState({
        name: "",
        password: "",
        passwordConfirmation: "",
        email: "",
        phone: "",
        country: "",
        confirmationStep: false,
        countryPrefix: "",
      });
    }
  }

  render() {
    const { name, password, passwordConfirmation, email, phone, country } =
      this.state;
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@_$!%*?&])[A-Za-z\d@_$!%*?&]{8,}$/;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const nameRegex = /^(?=.{1,100}$)[\p{L}\s.'-]+$/u;

    const isError =
      this.props.password !== "" && !passwordRegex.test(this.props.password);
    const rightValue = isError ? "30px" : "10px";
    const { passwordVisible } = this.state;
    const inputType = passwordVisible ? "text" : "password";

    const passwordValidated =
      this.state.password !== "" && !passwordRegex.test(this.state.password);
    const confirmPasswordValidated =
      this.state.password !== "" &&
      this.state.password !== this.state.passwordConfirmation;
    const emailValidated =
      this.state.email !== "" && !emailRegex.test(this.state.email);

    const phoneValidated =
      this.state.phone.length > 0 && !this.isPhoneNumberValid();
    const nameValidated = this.state.name !== "" && !nameRegex.test(name);
    return (
      <Modal
        show={this.props.show}
        style={{
          backgroundColor: "transparent",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "50%",
          overflowY: "scroll", // Use 'scroll' instead of 'auto'
          msOverflowStyle: "none", // Hide scrollbar for IE and Edge
          scrollbarWidth: "none", // Hide scrollbar for Firefox
        }}
        onHide={this.props.onHide}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header style={{ flex: 1 }}>
          <Modal.Title>{I18n.t("user_modalB2B/B2C")}</Modal.Title>
          <button className="clear" onClick={this.props.onHide}>
            <img src={Cross} alt="" />
          </button>
        </Modal.Header>
        <Modal.Body style={{ flex: 1, overflowY: "auto" }}>
          <Form onSubmit={this.handleSubmit}>
            <Form.Group controlId="formName">
              <Form.Label>
                {I18n.t("name_modalB2B/B2C")}
                <span style={{ color: "red" }}>*</span>
              </Form.Label>

              <Form.Control
                type="text"
                name={"name"}
                value={name}
                onChange={this.handleChange}
                disabled={this.state.confirmationStep}
                isInvalid={this.state.name !== "" && !nameRegex.test(name)}
                required
              />
            </Form.Group>

            <Form.Group controlId="formPassword">
              <Form.Label>
                {I18n.t("password_modalB2b/B2C")}
                <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <div style={{ position: "relative" }}>
                <Form.Control
                  type={inputType}
                  name="password"
                  value={password}
                  onChange={this.handleChange}
                  disabled={this.state.confirmationStep}
                  isInvalid={
                    this.state.password !== "" &&
                    !passwordRegex.test(this.state.password)
                  }
                  required
                />

                <img
                  src={eyePassword}
                  alt=""
                  style={{
                    position: "absolute",
                    right: rightValue,
                    top: "50%", // Adjust as needed
                    transform: "translateY(-50%)", // Center vertically
                    cursor: "pointer",
                  }}
                  onClick={this.togglePasswordVisibility}
                />
              </div>
              <div
                style={{
                  fontSize: 10,
                  paddingLeft: "3px",
                  paddingTop: "3px",
                  color: "ADB0B7",
                }}
              >
                {I18n.t("passwordRequirements_modalB2B/B2C")}
              </div>
            </Form.Group>

            <Form.Group controlId="formPasswordConfirmation">
              <Form.Label>
                {I18n.t("passwordConf_modalB2B/B2C")}
                <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                type="password"
                name="passwordConfirmation"
                value={passwordConfirmation}
                onChange={this.handleChange}
                disabled={this.state.confirmationStep}
                isInvalid={
                  this.state.password !== "" &&
                  this.state.password !== this.state.passwordConfirmation
                }
                required
              />
            </Form.Group>

            <Form.Group controlId="formEmail">
              <Form.Label>
                {I18n.t("email_modalB2B/B2C")}
                <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={email}
                onChange={this.handleChange}
                disabled={this.state.confirmationStep}
                isInvalid={
                  this.state.email !== "" && !emailRegex.test(this.state.email)
                }
                required
              />
            </Form.Group>

            <Form.Group controlId="formPhone">
              <Form.Label>
                {I18n.t("phone_modalB2B/B2C")}
                <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <div className="phone-input-container">
                <PhoneInput
                  disabled={this.state.confirmationStep}
                  placeholder={null}
                  autoFormat={false}
                  country={this.state.countryPrefix}
                  countryCodeEditable={false}
                  value={this.state.phone}
                  onChange={(value, country) =>
                    this.handleChangePhone2("phone", country, value)
                  }
                  tabIndex="1"
                  inputProps={{
                    name: "phone",
                    required: true,
                    autoFocus: true,
                  }}
                  required
                  buttonStyle={{
                    width: "2rem",
                    height: "80%",
                    marginLeft: "1rem",
                    marginTop: "0.25rem",
                    backgroundColor: "white",
                    border: "1px",
                  }}
                  inputStyle={{ borderRadius: "21px 21px 21px 21px" }}
                />
                <Form.Control.Feedback
                  type="invalid"
                  style={{
                    display: !this.isPhoneNumberValid() ? "block" : "none",
                  }}
                >
                  {this.state.phone.length > 0 &&
                    !this.isPhoneNumberValid() &&
                    I18n.t("backOffice_network_forms_invalid_phone")}
                </Form.Control.Feedback>
              </div>
            </Form.Group>

            <Form.Group controlId="formCountry">
              <Form.Label>
                {I18n.t("country_modalB2B/B2C")}
                <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <div className="select-container">
                <Form.Control
                  as={CountryDropdown}
                  value={
                    this.state.country && this.state.country !== ""
                      ? this.state.country
                      : "-"
                  }
                  onChange={(value) => this.setState({ country: value })}
                  disabled={this.state.confirmationStep}
                  required
                />
              </div>
            </Form.Group>
            <div style={{ color: "red" }}>
              <b>{I18n.t("requiredFields_modalB2B/B2C")}</b>
            </div>
            <div style={{ textAlign: "center" }} className="centered-container">
              {this.state.confirmationStep ? (
                <div>
                  <div>{I18n.t("creationConfirmation_modalB2B/B2C")}</div>
                  <Button type="submit" className="filterBtnModal">
                    {I18n.t("yes_modalB2B/B2C")}
                  </Button>
                  <Button
                    onClick={() => {
                      this.setState({ confirmationStep: false });
                    }}
                    className="filterBtnModal"
                    style={{ marginLeft: "1rem" }}
                  >
                    {I18n.t("no_modalB2B/B2C")}
                  </Button>
                </div>
              ) : (
                <div>
                  <Button
                    onClick={() => this.setState({ confirmationStep: true })}
                    className="filterBtnModal"
                    disabled={
                      !this.confirmAllFieldsAreFiled() ||
                      passwordValidated ||
                      confirmPasswordValidated ||
                      emailValidated ||
                      phoneValidated ||
                      nameValidated
                    }
                  >
                    {I18n.t("create_modalB2B/B2C")}
                  </Button>
                </div>
              )}
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  locale: state.i18n.locale,
  preferences: state.account.preferences,
  userPackage: state.account.accountData.userPackage,
  isAdmin: state.account.isAdmin,
  brand: state.app.brand,
});

export default connect(mapStateToProps, null)(CreateB2B);
